<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt($event)"
  (cancel)="cancel()"
  (confirm)="confirmManualSoilAnalysis($event)"
  data-test="edit-manual-soil-analysis"
>
  <div class="spacing--margin-top">
    <div>
      <mat-form-field>
        <mat-label>{{ 'manualSoilAnalysis.description' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'manualSoilAnalysis.description' | translate"
          formControlName="description"
          data-test="edit-manual-soil-analysis-description"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field data-test="edit-manual-soil-analysis-samplingDateTime">
        <mat-label>{{ 'manualSoilAnalysis.samplingDateTime' | translate }}</mat-label>
        <input
          matInput
          formControlName="samplingDateTime"
          [matDatepicker]="samplingDateTimePicker"
          [placeholder]="'manualSoilAnalysis.samplingDateTime' | translate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="samplingDateTimePicker"></mat-datepicker-toggle>
        <mat-datepicker #samplingDateTimePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <ng-container formGroupName="characteristics">
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.carbonToNitrogenRatio' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.carbonToNitrogenRatio' | translate"
            formControlName="carbonToNitrogenRatio"
            [step]="1"
            data-test="edit-manual-soil-analysis-carbonToNitrogenRatio"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.deliverableNitrogen' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.deliverableNitrogen' | translate"
            formControlName="deliverableNitrogen"
            [step]="1"
            data-test="edit-manual-soil-analysis-deliverableNitrogen"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.totalNitrogen' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.totalNitrogen' | translate"
            formControlName="totalNitrogen"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-totalNitrogen"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.minNitrogen' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.minNitrogen' | translate"
            formControlName="minNitrogen"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-minNitrogen"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.phosphorusAmmoniumLactate' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="
              'manualSoilAnalysis.characteristics.phosphorusAmmoniumLactate' | translate
            "
            formControlName="phosphorusAmmoniumLactate"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-phosphorusAmmoniumLactate"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.phosphorusNumber' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.phosphorusNumber' | translate"
            formControlName="phosphorusNumber"
            [step]="1"
            data-test="edit-manual-soil-analysis-phosphorusNumber"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.plantAvailablePhosphorus' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="
              'manualSoilAnalysis.characteristics.plantAvailablePhosphorus' | translate
            "
            formControlName="plantAvailablePhosphorus"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-plantAvailablePhosphorus"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.potassiumNumber' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.potassiumNumber' | translate"
            formControlName="potassiumNumber"
            [step]="1"
            data-test="edit-manual-soil-analysis-potassiumNumber"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.plantAvailableMagnesium' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.plantAvailableMagnesium' | translate"
            formControlName="plantAvailableMagnesium"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-plantAvailableMagnesium"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.calciumCarbonate' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.calciumCarbonate' | translate"
            formControlName="calciumCarbonate"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-calciumCarbonate"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.organicMatter' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.organicMatter' | translate"
            formControlName="organicMatter"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-organicMatter"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.soilAcidityNir' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.soilAcidityNir' | translate"
            formControlName="soilAcidityNir"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-soilAcidityNir"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.soilAcidity' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.soilAcidity' | translate"
            formControlName="soilAcidity"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-soilAcidity"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.ammoniaStock' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.ammoniaStock' | translate"
            formControlName="ammoniaStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-ammoniaStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.nitrateStock' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.nitrateStock' | translate"
            formControlName="nitrateStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-nitrateStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.plantAvailablePotassium' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.plantAvailablePotassium' | translate"
            formControlName="plantAvailablePotassium"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-plantAvailablePotassium"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.plantAvailableCalcium' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.plantAvailableCalcium' | translate"
            formControlName="plantAvailableCalcium"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-plantAvailableCalcium"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.calciumStock' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.calciumStock' | translate"
            formControlName="calciumStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-calciumStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.copperStock' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.copperStock' | translate"
            formControlName="copperStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-copperStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ 'manualSoilAnalysis.characteristics.ferroStock' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.ferroStock' | translate"
            formControlName="ferroStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-ferroStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.cationExchangeCapacity' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.cationExchangeCapacity' | translate"
            formControlName="cationExchangeCapacity"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-cationExchangeCapacity"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.calciumFilling' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.calciumFilling' | translate"
            formControlName="calciumFilling"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-calciumFilling"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.magnesiumFilling' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.magnesiumFilling' | translate"
            formControlName="magnesiumFilling"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-magnesiumFilling"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.potassiumFilling' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.potassiumFilling' | translate"
            formControlName="potassiumFilling"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-potassiumFilling"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{
            'manualSoilAnalysis.characteristics.sodiumFilling' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.sodiumFilling' | translate"
            formControlName="sodiumFilling"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-sodiumFilling"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.soilAvailablePotassium' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.soilAvailablePotassium' | translate"
            formControlName="soilAvailablePotassium"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-soilAvailablePotassium"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.potassiumStock' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.potassiumStock' | translate"
            formControlName="potassiumStock"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-potassiumStock"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'manualSoilAnalysis.characteristics.cecClayHumus' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [placeholder]="'manualSoilAnalysis.characteristics.cecClayHumus' | translate"
            formControlName="cecClayHumus"
            [step]="0.1"
            data-test="edit-manual-soil-analysis-cecClayHumus"
          />
        </mat-form-field>
      </div>
    </ng-container>
  </div>
</agr-form-dialog>
